import axios from 'axios'
import CreateProvince from './dto/CreateProvince'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedProvinceResultRequestDto} from './dto/PagedProvinceResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllProvinces from './dto/GetAllProvinces'
import UpdateProvince from './dto/UpdateProvince'
import GetProvince from './dto/GetProvince'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Province/Create`
export const URL_DELETE = `${API_URL}/Province/Delete`
export const URL_GET = `${API_URL}/Province/Get`
export const URL_GET_ALL = `${API_URL}/Province/GetPagedAll`
export const URL_UPDATE = `${API_URL}/Province/Update`

export function onCreateProvince(createProvince: CreateProvince): Promise<boolean> {
  return axios.post(URL_CREATE, createProvince)
}

export function onDeleteProvince(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetProvince(entityDto: EntityDto): Promise<GetProvince> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllProvinces(
  pagedFilterAndSortedRequest: PagedProvinceResultRequestDto
): Promise<PagedResultDto<GetAllProvinces>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateProvince(updateProvinceInput: UpdateProvince): Promise<boolean> {
  return axios.put(URL_UPDATE, updateProvinceInput)
}
